import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@talentmesh/ui/components/dialog';
import { cn } from '@talentmesh/ui/lib/utils';
import React from 'react';
import { LikertOption, Question, QuestionType } from '../../../../../../../../../Models/Questions';
import AnswerQuestionsPreview from '../AnswerQuestionsPreview';
import LikertQuestionsPreview from '../LikertQuestionsPreview';
import DialogHeader, { DialogHeaderProps } from './DialogHeader';
import { TestTypes } from '@/Models/Configuration';
import UIStrings from '@/Utils/UIStrings';

interface PreviewQuestionsDialogProps extends Omit<DialogHeaderProps, 'onClickClose'> {
    open: boolean;
    likertOptions?: LikertOption[];
    demoQuestions?: Question[];
    questionType?: QuestionType;
    testType: TestTypes;
    onClose: () => void;
}

const PreviewQuestionsDialog = ({
    onClose,
    pagination,
    onNext,
    onPrevious,
    testType,
    demoQuestions,
    likertOptions,
    questionType,
    open,
}: React.PropsWithChildren<PreviewQuestionsDialogProps>) => {
    const isAnswersType = questionType === QuestionType.Choice || questionType === QuestionType.Exact;

    return (
        <Dialog open={open} onOpenChange={(nextOpen) => !nextOpen && onClose()}>
            <DialogContent
                showCloseButton={false}
                className={cn(
                    'flex max-h-11/12 max-w-7xl flex-col gap-0 overflow-hidden p-0',
                    questionType === QuestionType.Likert ? 'bg-background' : 'bg-background',
                )}
            >
                <DialogTitle className="sr-only">{UIStrings.PreviewQuestions}</DialogTitle>
                <DialogDescription className="sr-only">{UIStrings.PreviewQuestions}</DialogDescription>
                <DialogHeader
                    pagination={pagination}
                    onClickClose={onClose}
                    testType={testType}
                    onNext={onNext}
                    onPrevious={onPrevious}
                />
                {isAnswersType ? (
                    <div className="from-muted to-background min-h-160 flex-1 overflow-auto bg-linear-to-r from-50% to-50%">
                        <AnswerQuestionsPreview demoQuestion={demoQuestions![pagination.index]} />
                    </div>
                ) : (
                    <LikertQuestionsPreview demoQuestions={demoQuestions!} likertOptions={likertOptions!} />
                )}
            </DialogContent>
        </Dialog>
    );
};

export default PreviewQuestionsDialog;
